import { CompanyType } from "../types";

export const getCompanyTypeName = (id: number, companyTypes?: CompanyType[]): string => {
    if (!companyTypes) return "";
    const ct = companyTypes.filter( (ct => { return ct.id === id} ))[0];
    return ct ? ct.text : "";
}